var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dapp-card"},[(_vm.title)?_c('div',{staticClass:"dapp-card__header"},[_c('span',{staticClass:"dapp-card__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("button")],2):_vm._e(),_c('div',{class:{ 'no-borders': !_vm.showBorders, 'dapp-card__inner': _vm.title }},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }